import React, { memo } from 'react';
import { RefreshListIcons } from '../../../../../../icons/icons';

export interface RefreshButtonProps {
  onRefresh: () => void;
  loading?: boolean;
  disabled?: boolean;
}

export const RefreshButton = memo<RefreshButtonProps>(
  ({ onRefresh, loading = false, disabled = false }) => (
    <button
        onClick={onRefresh}
        disabled={disabled || loading}
        className={`group relative h-8 px-2.5 rounded-lg transition-all duration-300 flex items-center justify-center gap-1.5 shrink-0 whitespace-nowrap ${
          disabled || loading
            ? 'bg-transparent text-slate-300 cursor-not-allowed opacity-40'
            : 'bg-transparent text-slate-600 hover:bg-slate-100/80 active:bg-slate-200/50'
        }`}
        title={loading ? 'Refreshing data...' : 'Refresh chart data'}
        aria-label={loading ? 'Refreshing data...' : 'Refresh chart data'}
    >
      <RefreshListIcons
          className={`w-3.5 h-3.5 transition-all duration-300 ${
            loading
              ? 'animate-spin text-gray-400'
              : 'text-slate-600 group-hover:text-emerald-600'
          }`}
      />
      <span className='hidden lg:inline text-xs font-medium'>
        { loading ? 'Refreshing...' : 'Refresh' }
      </span>
    </button>
  ),
);

RefreshButton.displayName = 'RefreshButton';
